import { Link, useLocation } from 'react-router-dom';

import { buildCrumbs } from './buildCrumbs';
import styles from './Breadcrumbs.module.css';

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const crumbs = buildCrumbs(pathname);

  return (
    <nav className={styles.crumbs} aria-label="פירורי לחם">
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={`${c.label}-${String(i)}`} className={styles.crumbs}>
            {i > 0 ? <span className={styles.sep} aria-hidden="true">/</span> : null}
            {isLast || !c.to ? (
              <span className={styles.current}>{c.label}</span>
            ) : (
              <Link to={c.to} className={styles.link}>{c.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
